import { isDefined, randomUUID } from '@aloft/toolkit-shared';
import { Block, SimpleTextArea } from '@aloft/toolkit-sui';

import { setMarketAdjustmentsCommentary } from '../../../redux/features/orderSlice.ts';
import { selectMarketAdjustmentsCommentaryData } from '../../../redux/features/selectors/commentarySelectors/selectMarketAdjustmentsCommentary.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { ZillowHomeValueIndexTrendsChartUnwrapped } from '../../marketConditions/zillow/ZillowHomeValueIndexTrendsChart.tsx';
import { CommentaryChartContainer } from '../components/CommentaryChartContainer.tsx';
import { CommentaryDateOfSaleTable } from '../components/CommentaryDateOfSaleTable.tsx';
import { CommentaryListToSale } from '../components/CommentaryListToSale.tsx';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { getCommentarySectionText } from '../utils.ts';

export const MarketAdjustments = ({
  isModal = false,
  title = 'date-of-sale-adjustments',
}: {
  isModal?: boolean;
  title?: 'date-of-sale-adjustments' | 'market-condition';
}) => {
  const data = useAppSelector((state) => selectMarketAdjustmentsCommentaryData(state));
  const dispatch = useAppDispatch();

  return (
    <CommentarySection {...getCommentarySectionText(title)}>
      {isDefined(data) && (
        <>
          {data.chart && (
            <CommentaryChartContainer
              title={data.method === 'zillow' ? 'Zillow Home Value Index' : 'Custom Home Value Index'}
            >
              <ZillowHomeValueIndexTrendsChartUnwrapped {...data.chart} reduceFontSize={isModal} />
            </CommentaryChartContainer>
          )}
          {data.table?.map((table, index) => (
            <CommentaryDateOfSaleTable
              key={randomUUID()}
              data={table}
              helperText={
                index === (data.table?.length ?? 0) - 1 && data.listToSaleMethod !== 'customRatio'
                  ? data.helperText
                  : undefined
              }
            />
          ))}
          {data.listToSaleMethod === 'customRatio' && (
            <CommentaryListToSale
              chartData={data.comparableSalesDataTable}
              ratio={data.listToSaleRatio}
              helperText={data.helperText}
            />
          )}
          <Block maxWidth="40rem">
            <SimpleTextArea
              value={data.commentary}
              onChange={(e) =>
                dispatch(setMarketAdjustmentsCommentary({ commentary: e.target.value }))
              }
              size="lg"
              label="Commentary"
            />
          </Block>
        </>
      )}
    </CommentarySection>
  );
};
